













































import company from '@/store/types/company';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { responseDataPagination } from '@/store/interfaces/json-api/generics';
import { CompanyParams } from '@/store/interfaces/company';
import { mapMutations } from 'vuex';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Companies',
  props: {
    tableData: {
      required: true,
      type: Object as PropType<responseDataPagination<CompanyParams>>,
    },
    fetch: {
      required: true,
      type: Function,
    },
  },
  data() {
    return {
      propsToSearch: ['business_name_cont'] as tPropsToSearch,
      tableColumns: [
        {
          prop: 'business_name',
          label: '', // assigned in created function
          minWidth: 250,
          sortable: true,
        },
        {
          prop: 'address.description',
          label: 'Dirección',
          minWidth: 220,
          sortable: true,
        },
        {
          prop: 'address.phone',
          label: 'Teléfono',
          minWidth: 220,
          sortable: true,
        }
      ] as tTableColumns,
      rowSelected: {},
    };
  },
  created(): void {
    this.$data.tableColumns[0].label = this.$t(
      'menu.company.singular.formal'
    ).toString();
  },
  methods: {
    ...mapMutations({
      singleCompany: `companyModule/${company.mutations.SET_SINGLE_COMPANY}`,
    }),
    rowselect(row: unknown): void {
      this.$data.rowSelected = row;
      this.singleCompany(row);
    },
    newCommerce(): void {
      this.$router.push({
        path: `/commerce/new-commerce/company/${this.$data.rowSelected.id}`,
      });
    },
    goProfile(): void {
      this.$router.push({
        name: 'company-profile',
        params: { company_id: this.$data.rowSelected.id, },
      });
    },
  },
  computed: {
    tableDataSync: {
      get(): responseDataPagination<CompanyParams> {
        return this.tableData;
      },
      set(value: responseDataPagination<CompanyParams>): void {
        this.$emit('update:tableData', value);
      },
    },
  },
});
